var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export function propMerge(defaults) {
  var overrides = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    overrides[_i - 1] = arguments[_i];
  }
  var output = __assign({}, defaults);
  overrides.forEach(function (props) {
    for (var key in props) {
      if (props[key] !== undefined) {
        var propsValue = props[key];
        var defaultsValue = output === null || output === void 0 ? void 0 : output[key]; // Using defaults?.[key] for added safety
        if (typeof propsValue === 'object' && typeof defaultsValue === 'object' && propsValue !== null && !Array.isArray(propsValue)) {
          output[key] = propMerge(defaultsValue, propsValue);
        } else {
          output[key] = propsValue;
        }
      }
    }
  });
  return output;
}
;